/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { createEnum } from 'fierry/util/enum';


export default createEnum('Default', 'Direction');
